import { useSelector } from 'react-redux';

import { useNavigation } from '@atom/hooks/useNavigation';
import { usePreferences } from '@atom/hooks/usePreferences';
import { Icon, IconButton } from '@atom/mui';
import { knowledgeCenterLinkSelector } from '@atom/selectors/preferencesSelectors';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

import AskAIButton from './AskAIButton';
import CreateControls from './CreateControls';
import Portal from './Portal';
import Profile from './Profile';

import classes from './navigation.module.css';

const NavControls = () => {
  const preferences = usePreferences();
  const [, { pathname }] = useNavigation();
  const link = useSelector(knowledgeCenterLinkSelector);
  const isAiEnabled = !!preferences?.ai?.enabled;
  const aiRoleSet = preferences?.ai?.roleSet;
  const hasPermission = aiRoleSet && hasRolePermissions(ROLE_SETS[aiRoleSet]);
  const showAi = isAiEnabled && hasPermission;

  return (
    <div className={classes.navControlsContainer}>
      <div className={classes.additionalButtonsWrapper}>
        <div className={classes.additionalButtonsContainer}>
          {showAi && <AskAIButton />}
          <IconButton
            size="small"
            tooltip="Knowledge Center"
            target="_blank"
            href={link}
          >
            <Icon>help_outline</Icon>
          </IconButton>
        </div>
      </div>
      {hasRolePermissions(ROLE_SETS.INSPECTOR) && <CreateControls />}
      <Portal pathname={pathname} />
      <Profile />
    </div>
  );
};

export default NavControls;
